import { useEffect } from 'react'
import { isWeb } from 'tamagui'
import { useSession } from '@hooks/useSession'
import { setPreviewMode } from '@services/api/previewMode'

/**
 * Visão do produtor sobre a área do aluno.
 *
 * Só existe na web: os CTAs que levam até aqui vivem no painel (xavier), e o
 * app nativo é exclusivamente do aluno. O modo é derivado do tipo do usuário
 * autenticado, não de um parâmetro na URL — quem não é colaborador não entra
 * em preview nem forçando o path.
 */
export const useAdminPreview = () => {
  const { user } = useSession()

  const isPreview = isWeb && user?.type === 'Collaborator'

  useEffect(() => {
    setPreviewMode(isPreview)
  }, [isPreview])

  return { isPreview }
}
